import React, { useEffect, useState } from 'react';
import DateTimeDisplay from './DateTimeDisplay';

const Timer = ({ initialTime, timerType, onResend }) => {
  const [remainingTime, setRemainingTime] = useState(initialTime);

  const handleResend = () => {
    setRemainingTime(initialTime);
    onResend();
  };

  useEffect(() => {
    if (remainingTime <= 0) {
      setRemainingTime(0);
      return;
    }

    const interval = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [remainingTime]);

  const [days, hours, minutes, seconds] = getReturnValues(remainingTime);

  return (
    <>
      {remainingTime <= 0 ? (
        <button
          type="button"
          className="text-light-blue text-sm pb-3 text-center absolute -top-[24px] left-0"
          onClick={handleResend}
        >
          دریافت مجدد کد
        </button>
      ) : (
        <div className="flex text-light-blue justify-center mb-2 items-center absolute -top-[24px] left-0">
          <span className="text-xs pl-1">زمان تا درخواست مجدد: </span>
          <ShowCounter
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            timerType={timerType}
          />
        </div>
      )}
    </>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds, timerType }) => {
  return (
    <div className="show-counter flex flex-row-reverse justify-center">
      {timerType !== 'otp' && (
        <>
          <DateTimeDisplay value={days} type="D" isDanger={days <= 3} />
          <p>:</p>
          <DateTimeDisplay value={hours} type="H" isDanger={false} />
          <p>:</p>
        </>
      )}
      <DateTimeDisplay value={minutes} type="M" isDanger={false} />
      <p>:</p>
      <DateTimeDisplay value={seconds} type="S" isDanger={false} />
    </div>
  );
};

const getReturnValues = (countDown) => {
  const days = Math.floor(countDown / (60 * 60 * 24));
  const hours = Math.floor((countDown % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((countDown % (60 * 60)) / 60);
  const seconds = Math.floor(countDown % 60);

  return [days, hours, minutes, seconds];
};

export default Timer;
